import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  DatePicker,
  Row,
  Col,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
} from "react";
import { EditOutlined, BankOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
// import UploadFile from "@/components/UploadFileBank";
const AddModal = forwardRef((props, ref) => {
  const [bankList, setBankList] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const bankBalanceRef = useRef();
  const bankStatementRef = useRef();

  const { onSuccess } = props;
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      form.resetFields();
      setVisible(true);
      await loadCopyFromBank(); // 只加载一次
    },
  }));
  const loadCopyFromBank = async () => {
    setBankLoading(true);
    const res = await http.get(`${api.getBackDictList}`);
    setBankList(res.data || []);
    setBankLoading(false);
  };

  function useLazySelect(apiUrl, cacheKey, mapper, enableCache = true) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async (params = {}) => {
      if (options.length && enableCache) return;

      setLoading(true);
      let res;

      // 带参数
      if (params && Object.keys(params).length > 0) {
        res = await http.get(apiUrl, { params });
      } else {
        res = await http.get(apiUrl);
      }

      const raw = res?.data || [];

      setOptions(mapper(raw));
      setLoading(false);
    };

    return { options, loading, load };
  }
  const vendorSelect = useLazySelect(api.vendorSearch, "vendor", (data) =>
    data.map((item) => ({
      value: item.vendorId,
      label: item.vendorName,
      glChartNameId: item.glChartNameId,
    }))
  );

  const onVendorChange = async (vendorId) => {
    const vendor = vendorSelect.options.find((item) => item.value === vendorId);
    if (!vendor) return;

    const glChartNameId = vendor.glChartNameId;
  };

  const addUpload = async (files, fieldType, form) => {
    if (!files?.length) return;

    const fileList = form.getFieldValue("fileList") || [];

    for (const file of files) {
      try {
        const uploaded = await uploadSingleFile(file, fieldType);

        const exists = fileList.some((f) => f.uid === file.uid);
        if (exists) continue;

        fileList.push({
          type: uploaded.type,
          path: uploaded.path,
          fileName: uploaded.fileName,
          status: uploaded.status ?? 0,
          uid: file.uid,
          url:file.url,
        });
        // 标记为已上传，避免重复传
        file._uploaded = true;
      } catch (e) {
        message.error(`${file.name || "File"} upload failed`);
      }
    }
    form.setFieldsValue({ fileList });
    form.validateFields(["bankBalance"]);
  };
  const uploadSingleFile = async (file, fieldType) => {
    const foreignId = "q1FJeKGXg6l9DKvolVahqXl2477uRIwqcj9lNfRK";
    const formData = new FormData();
    formData.append("files", file.originFileObj);
    // formData.append("foreignId", foreignId);
    formData.append("type", fieldType);

    const res = await http.post(api.getMortgageUpload, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res.code === "1") return res.data[0];
    throw new Error(res.msg || "Upload failed");
  };
  // 删除
  const handleRemove = (file) => {
    const { uid } = file;
    const list = form.getFieldValue("fileList") || [];
    const newList = list.filter((f) => f.uid !== uid);
    form.setFieldsValue({ fileList: newList });
    bankBalanceRef.current?.removeByUid(uid);
    bankStatementRef.current?.removeByUid(uid);
  };

  // 提交
  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const fileList = form.getFieldValue("fileList") || [];
      const params = {
        name: values?.name || undefined,
        street: values?.street || undefined,
        city: values?.city || undefined,
        state: values?.state || undefined,
        zip: values?.zip || undefined,
        phone: values?.phone || undefined,
        transitCp: values?.transitCp || undefined,
        cpAcct: values?.cpAcct || undefined,
        managementCompanyId: values?.managementCompanyId || undefined,
        trustId: values?.trustId || undefined,
        bank: values?.bank || undefined,
        remark: values?.remark || undefined,
        lastCheckNo: values?.lastCheckNo || undefined,
        glAcct: values?.glAcct || undefined,
        isNeedRec: values?.isNeedRec || undefined,
        positivePay: values?.positivePay || undefined,
        baiFile: values?.baiFile || undefined,
        balance: values?.balance || undefined,
        active: values?.active || undefined,
        fileList: fileList.map(({ uid, ...rest }) => rest),
      };
      // console.log("请求参数:", params);
      const res = await http.post(api.getBankAdd, params);
      if (res?.code === "1") {
        message.success("Bank Created Successfully");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            CREATE BANK MORTGAGE ROLLING
          </Typography.Title>
        </Flex>
      }
      width="80%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      maskClosable={false}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>,
      ]}
    >
      <Row gutter={24}>
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex align="flex-start" justify="space-between" gap={8}>
                {/* ========== 左侧：Bank Detail ========== */}
                <Col span={9}>
                  <div className="modal-section-title">
                    <BankOutlined /> Bank Mortgage Rolling Detail
                  </div>
                  <Form.Item
                    name="monthlyPayment"
                    label="Monthly"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Monthly" />
                  </Form.Item>

                  <Form.Item name="originalLoan" label="Original Loan">
                    <Input placeholder="originalLoan" />
                  </Form.Item>

                  <Form.Item name="currentLoan" label="Current Loan">
                    <Input placeholder="Current Loan" />
                  </Form.Item>

                  <Form.Item
                    name="vendorId"
                    label="Vendor"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Vendor"
                      loading={vendorSelect.loading}
                      options={vendorSelect.options}
                      onDropdownVisibleChange={(open) =>
                        open && vendorSelect.load()
                      }
                      onChange={onVendorChange}
                    />
                  </Form.Item>

                  <Form.Item
                    name="vendorName"
                    label="Lender"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Lender" />
                  </Form.Item>
                  <Form.Item
                    name="loanNumber"
                    label="Loan Number"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Loan Number" />
                  </Form.Item>

                  <Form.Item
                    name="interestRate"
                    label="Interest Rate"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Interest Rate" />
                  </Form.Item>

                  <Form.Item
                    name="loanDateStr"
                    label="loanDate"
                    rules={[
                      {
                        required: true,
                        message: "Please select loanDate.",
                      },
                    ]}
                  >
                    <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                  </Form.Item>

                  <Form.Item
                    name="loanEndDateStr"
                    label="loanEndDate"
                    rules={[
                      {
                        required: true,
                        message: "Please select loanEndDate.",
                      },
                    ]}
                  >
                    <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                  </Form.Item>

                  <Form.Item
                    name="fixRate"
                    label="Fix Rate"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Fix Rate" />
                  </Form.Item>

                  <Form.Item
                    name="variableRate"
                    label="Variable Rate"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Variable Rate" />
                  </Form.Item>

                  <Form.Item
                    name="isSwap"
                    label="Is Swap"
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={9}>
                  <div style={{ height: 45, visibility: "hidden" }}></div>

                  <Form.Item
                    name="fixEndDateStr"
                    label="Swap/Fix End Date"
                    rules={[
                      {
                        required: true,
                        message: "Please select Swap/Fix End Date.",
                      },
                    ]}
                  >
                    <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
                  </Form.Item>

                  <Form.Item
                    name="termPeriod"
                    label="Term Period"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Term Period" />
                  </Form.Item>

                  <Form.Item
                    name="amortPeriod"
                    label="Amort Period"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Amort Period" />
                  </Form.Item>

                  <Form.Item name="variableIndex" label="Variable Index">
                    <Input placeholder="Variable Index" />
                  </Form.Item>

                  <Form.Item name="marginRate" label="Margin">
                    <Input placeholder="Margin" />
                  </Form.Item>

                  <Form.Item name="loanType" label="Loan Type">
                    <Input placeholder="Loan Type" />
                  </Form.Item>

                  <Form.Item
                    name="recourse"
                    label="Recourse"
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item name="ceiling" label="Ceiling">
                    <Input placeholder="Ceiling" />
                  </Form.Item>

                  <Form.Item name="floor" label="Floor">
                    <Input placeholder="Floor" />
                  </Form.Item>

                  <Form.Item name="balloonPayment" label="Balloon Payment">
                    <Input placeholder="Balloon Payment" />
                  </Form.Item>

                  <Form.Item
                    name="isAch"
                    label="Ach"
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>

                  <Form.Item
                    name="isDscr"
                    label="DSCR"
                    rules={[{ required: true }]}
                  >
                    <Select
                      options={[
                        { value: "1", label: "Yes" },
                        { value: "0", label: "No" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  {/* upload */}
                  <div
                    style={{
                      marginBottom: "16px",
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                  >
                    Upload PDF image
                  </div>
                  <Form.Item
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    label={null}
                  >
                    <div>
                      {/* <div className="uploadText">
                        Uploaded files only support JPG, PNG or PDF.
                      </div> */}
                      <div style={{ marginTop: "20px" }}>
                        <div style={{ flex: 1 }}>
                          {/* <div
                            style={{ fontWeight: "bold", marginBottom: "8px" }}
                          >
                            Upload Bank Balance
                          </div> */}
                          <Form.Item name="bankBalance" noStyle>
                            {/* <UploadFile
                              ref={bankBalanceRef}
                              onSelectFiles={(files) =>
                                addUpload(files, "bankBalance", form)
                              }
                              onFileRemove={handleRemove}
                              accept=".pdf,.jpg,.png"
                            /> */}
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <Form.Item name="fileList" hidden />
                  </Form.Item>
                </Col>
              </Flex>
            </Form>
          </div>
        </div>
      </Row>
    </Modal>
  );
});

export default AddModal;
